var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.6654 5.33335V13.3334M30.6654 13.3334H22.6654M30.6654 13.3334L24.4787 7.52002C23.0457 6.0863 21.2729 5.03896 19.3256 4.47572C17.3784 3.91247 15.3202 3.85169 13.3431 4.29903C11.366 4.74637 9.53443 5.68726 8.01932 7.03391C6.50421 8.38056 5.35492 10.0891 4.6787 12M1.33203 26.6667V18.6667M1.33203 18.6667H9.33203M1.33203 18.6667L7.5187 24.48C8.95169 25.9137 10.7245 26.9611 12.6718 27.5243C14.619 28.0876 16.6772 28.1483 18.6543 27.701C20.6314 27.2537 22.463 26.3128 23.9781 24.9661C25.4932 23.6195 26.6425 21.911 27.3187 20",
    stroke: "#00AD3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw);
export default __webpack_public_path__ + "static/media/refresh-cw.be9b4268d5fffacb041e74533412934f.svg";
export { ForwardRef as ReactComponent };